import { shouldDisplayDiscountCode } from "@/utils/discount-code-client";
import { useBreakpointValue } from "@chakra-ui/react";

export default function DiscountText({ discountCode, discountPct, discountMultiplier }) {
  const isValuePackage = discountMultiplier > 1;
  const shouldDisplay = shouldDisplayDiscountCode(discountCode);

  const isMobile = useBreakpointValue({ base: true, md: false });

  const suffix = isValuePackage ? (
    <>
      <b>{discountMultiplier}X</b> more unlocks
      {!isMobile && " for all packages"}.
    </>
  ) : (
    <>
      <b>{(discountPct * 100).toString()}%</b> off all packages.
    </>
  );

  if (shouldDisplay) {
    if (discountCode === "ADMITGHOST50") {
      return (
        <>
          {`👻Don't Ghost Your University Applications! Get 50% off with code
          "ADMITGHOST50". 24 hours only! 👻`}
        </>
      );
    }

    return (
      <>
        Using <b>{discountCode.toUpperCase()}</b> discount for {suffix}
      </>
    );
  } else {
    return <>Sitewide Sale: {suffix}</>;
  }
}
